import classNames from 'classnames/bind';
import {
  DropdownMenu,
  DropdownOption,
  useDropdown,
} from 'containers/Shared/components/Dropdown';
import { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Background,
  BackgroundType,
} from 'containers/Appointments/useControls';

const TriggerIcon = ({
  className,
  starClassName,
}: {
  className?: string;
  starClassName?: string;
}) => {
  return (
    <div className="relative">
      <svg
        className={className}
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.75 1.5C15.6498 1.5 7.5 1.5 7.5 1.5C5.3998 1.5 4.3497 1.5 3.54754 1.90873C2.84193 2.26825 2.26825 2.84193 1.90873 3.54754C1.5 4.3497 1.5 5.3998 1.5 7.5V20.5C1.5 22.6002 1.5 23.6503 1.90873 24.4525C2.26825 25.1581 2.84193 25.7317 3.54754 26.0913C3.68917 26.1634 3.83853 26.2229 4.00003 26.2718M26.5 10.0493C26.5 15.1262 26.5 20.5 26.5 20.5C26.5 22.6002 26.5 23.6503 26.0913 24.4525C25.7317 25.1581 25.1581 25.7317 24.4525 26.0913C24.3108 26.1634 24.1615 26.2229 24 26.2718M4.00003 26.2718C4.75325 26.5 5.77061 26.5 7.5 26.5H20.5C22.2294 26.5 23.2467 26.5 24 26.2718M4.00003 26.2718C4.00044 25.2601 4.00651 24.7248 4.09607 24.2745C4.49061 22.2911 6.0411 20.7406 8.02455 20.3461C8.50754 20.25 9.08836 20.25 10.25 20.25H17.75C18.9116 20.25 19.4925 20.25 19.9755 20.3461C21.9589 20.7406 23.5094 22.2911 23.9039 24.2745C23.9935 24.7248 23.9996 25.2601 24 26.2718M19 10.875C19 13.6364 16.7614 15.875 14 15.875C11.2386 15.875 9 13.6364 9 10.875C9 8.11358 11.2386 5.875 14 5.875C16.7614 5.875 19 8.11358 19 10.875Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      <svg
        className={classNames(
          'absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2',
          starClassName
        )}
        width="13"
        height="12"
        viewBox="0 0 13 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.19147 -0.00585938L6.97237 3.11774C7.12474 3.72725 7.20093 4.03201 7.35962 4.27999C7.49998 4.49935 7.68626 4.68563 7.90561 4.82599C8.1536 4.98467 8.45836 5.06086 9.06787 5.21324L12.1915 5.99414L9.06787 6.77504C8.45836 6.92742 8.1536 7.00361 7.90561 7.16229C7.68626 7.30265 7.49998 7.48894 7.35962 7.70829C7.20093 7.95627 7.12474 8.26103 6.97237 8.87055L6.19147 11.9941L5.41057 8.87055C5.25819 8.26103 5.182 7.95627 5.02332 7.70829C4.88296 7.48894 4.69667 7.30265 4.47732 7.16229C4.22933 7.00361 3.92458 6.92742 3.31506 6.77504L0.191467 5.99414L3.31506 5.21324C3.92458 5.06086 4.22933 4.98467 4.47732 4.82599C4.69667 4.68563 4.88296 4.49935 5.02332 4.27999C5.182 4.03201 5.25819 3.72725 5.41057 3.11773L6.19147 -0.00585938Z"
          fill="currentColor"
        />
        <path
          d="M6.19147 -0.00585938L6.97237 3.11774C7.12474 3.72725 7.20093 4.03201 7.35962 4.27999C7.49998 4.49935 7.68626 4.68563 7.90561 4.82599C8.1536 4.98467 8.45836 5.06086 9.06787 5.21324L12.1915 5.99414L9.06787 6.77504C8.45836 6.92742 8.1536 7.00361 7.90561 7.16229C7.68626 7.30265 7.49998 7.48894 7.35962 7.70829C7.20093 7.95627 7.12474 8.26103 6.97237 8.87055L6.19147 11.9941L5.41057 8.87055C5.25819 8.26103 5.182 7.95627 5.02332 7.70829C4.88296 7.48894 4.69667 7.30265 4.47732 7.16229C4.22933 7.00361 3.92458 6.92742 3.31506 6.77504L0.191467 5.99414L3.31506 5.21324C3.92458 5.06086 4.22933 4.98467 4.47732 4.82599C4.69667 4.68563 4.88296 4.49935 5.02332 4.27999C5.182 4.03201 5.25819 3.72725 5.41057 3.11773L6.19147 -0.00585938Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
};

const BlurIcon = (props: ComponentProps<'svg'>) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.99996 8.91553C3.63329 8.91553 3.33329 9.21553 3.33329 9.58219C3.33329 9.94886 3.63329 10.2489 3.99996 10.2489C4.36663 10.2489 4.66663 9.94886 4.66663 9.58219C4.66663 9.21553 4.36663 8.91553 3.99996 8.91553ZM3.99996 11.5822C3.63329 11.5822 3.33329 11.8822 3.33329 12.2489C3.33329 12.6155 3.63329 12.9155 3.99996 12.9155C4.36663 12.9155 4.66663 12.6155 4.66663 12.2489C4.66663 11.8822 4.36663 11.5822 3.99996 11.5822ZM3.99996 6.24886C3.63329 6.24886 3.33329 6.54886 3.33329 6.91553C3.33329 7.28219 3.63329 7.58219 3.99996 7.58219C4.36663 7.58219 4.66663 7.28219 4.66663 6.91553C4.66663 6.54886 4.36663 6.24886 3.99996 6.24886ZM1.99996 6.58219C1.81329 6.58219 1.66663 6.72886 1.66663 6.91553C1.66663 7.10219 1.81329 7.24886 1.99996 7.24886C2.18663 7.24886 2.33329 7.10219 2.33329 6.91553C2.33329 6.72886 2.18663 6.58219 1.99996 6.58219ZM3.99996 3.58219C3.63329 3.58219 3.33329 3.88219 3.33329 4.24886C3.33329 4.61553 3.63329 4.91553 3.99996 4.91553C4.36663 4.91553 4.66663 4.61553 4.66663 4.24886C4.66663 3.88219 4.36663 3.58219 3.99996 3.58219ZM14 7.24886C14.1866 7.24886 14.3333 7.10219 14.3333 6.91553C14.3333 6.72886 14.1866 6.58219 14 6.58219C13.8133 6.58219 13.6666 6.72886 13.6666 6.91553C13.6666 7.10219 13.8133 7.24886 14 7.24886ZM9.33329 4.91553C9.69996 4.91553 9.99996 4.61553 9.99996 4.24886C9.99996 3.88219 9.69996 3.58219 9.33329 3.58219C8.96663 3.58219 8.66663 3.88219 8.66663 4.24886C8.66663 4.61553 8.96663 4.91553 9.33329 4.91553ZM9.33329 2.58219C9.51996 2.58219 9.66663 2.43553 9.66663 2.24886C9.66663 2.06219 9.51996 1.91553 9.33329 1.91553C9.14663 1.91553 8.99996 2.06219 8.99996 2.24886C8.99996 2.43553 9.14663 2.58219 9.33329 2.58219ZM1.99996 9.24886C1.81329 9.24886 1.66663 9.39553 1.66663 9.58219C1.66663 9.76886 1.81329 9.91553 1.99996 9.91553C2.18663 9.91553 2.33329 9.76886 2.33329 9.58219C2.33329 9.39553 2.18663 9.24886 1.99996 9.24886ZM6.66663 13.9155C6.47996 13.9155 6.33329 14.0622 6.33329 14.2489C6.33329 14.4355 6.47996 14.5822 6.66663 14.5822C6.85329 14.5822 6.99996 14.4355 6.99996 14.2489C6.99996 14.0622 6.85329 13.9155 6.66663 13.9155ZM6.66663 2.58219C6.85329 2.58219 6.99996 2.43553 6.99996 2.24886C6.99996 2.06219 6.85329 1.91553 6.66663 1.91553C6.47996 1.91553 6.33329 2.06219 6.33329 2.24886C6.33329 2.43553 6.47996 2.58219 6.66663 2.58219ZM6.66663 4.91553C7.03329 4.91553 7.33329 4.61553 7.33329 4.24886C7.33329 3.88219 7.03329 3.58219 6.66663 3.58219C6.29996 3.58219 5.99996 3.88219 5.99996 4.24886C5.99996 4.61553 6.29996 4.91553 6.66663 4.91553ZM6.66663 8.58219C6.11329 8.58219 5.66663 9.02886 5.66663 9.58219C5.66663 10.1355 6.11329 10.5822 6.66663 10.5822C7.21996 10.5822 7.66663 10.1355 7.66663 9.58219C7.66663 9.02886 7.21996 8.58219 6.66663 8.58219ZM12 8.91553C11.6333 8.91553 11.3333 9.21553 11.3333 9.58219C11.3333 9.94886 11.6333 10.2489 12 10.2489C12.3666 10.2489 12.6666 9.94886 12.6666 9.58219C12.6666 9.21553 12.3666 8.91553 12 8.91553ZM12 11.5822C11.6333 11.5822 11.3333 11.8822 11.3333 12.2489C11.3333 12.6155 11.6333 12.9155 12 12.9155C12.3666 12.9155 12.6666 12.6155 12.6666 12.2489C12.6666 11.8822 12.3666 11.5822 12 11.5822ZM12 6.24886C11.6333 6.24886 11.3333 6.54886 11.3333 6.91553C11.3333 7.28219 11.6333 7.58219 12 7.58219C12.3666 7.58219 12.6666 7.28219 12.6666 6.91553C12.6666 6.54886 12.3666 6.24886 12 6.24886ZM12 3.58219C11.6333 3.58219 11.3333 3.88219 11.3333 4.24886C11.3333 4.61553 11.6333 4.91553 12 4.91553C12.3666 4.91553 12.6666 4.61553 12.6666 4.24886C12.6666 3.88219 12.3666 3.58219 12 3.58219ZM14 9.24886C13.8133 9.24886 13.6666 9.39553 13.6666 9.58219C13.6666 9.76886 13.8133 9.91553 14 9.91553C14.1866 9.91553 14.3333 9.76886 14.3333 9.58219C14.3333 9.39553 14.1866 9.24886 14 9.24886ZM9.33329 11.5822C8.96663 11.5822 8.66663 11.8822 8.66663 12.2489C8.66663 12.6155 8.96663 12.9155 9.33329 12.9155C9.69996 12.9155 9.99996 12.6155 9.99996 12.2489C9.99996 11.8822 9.69996 11.5822 9.33329 11.5822ZM9.33329 13.9155C9.14663 13.9155 8.99996 14.0622 8.99996 14.2489C8.99996 14.4355 9.14663 14.5822 9.33329 14.5822C9.51996 14.5822 9.66663 14.4355 9.66663 14.2489C9.66663 14.0622 9.51996 13.9155 9.33329 13.9155ZM6.66663 5.91553C6.11329 5.91553 5.66663 6.36219 5.66663 6.91553C5.66663 7.46886 6.11329 7.91553 6.66663 7.91553C7.21996 7.91553 7.66663 7.46886 7.66663 6.91553C7.66663 6.36219 7.21996 5.91553 6.66663 5.91553ZM6.66663 11.5822C6.29996 11.5822 5.99996 11.8822 5.99996 12.2489C5.99996 12.6155 6.29996 12.9155 6.66663 12.9155C7.03329 12.9155 7.33329 12.6155 7.33329 12.2489C7.33329 11.8822 7.03329 11.5822 6.66663 11.5822ZM9.33329 8.58219C8.77996 8.58219 8.33329 9.02886 8.33329 9.58219C8.33329 10.1355 8.77996 10.5822 9.33329 10.5822C9.88663 10.5822 10.3333 10.1355 10.3333 9.58219C10.3333 9.02886 9.88663 8.58219 9.33329 8.58219ZM9.33329 5.91553C8.77996 5.91553 8.33329 6.36219 8.33329 6.91553C8.33329 7.46886 8.77996 7.91553 9.33329 7.91553C9.88663 7.91553 10.3333 7.46886 10.3333 6.91553C10.3333 6.36219 9.88663 5.91553 9.33329 5.91553Z"
      fill="currentColor"
    />
  </svg>
);

const ImageIcon = (props: ComponentProps<'svg'>) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.8 14.249H4.62091C4.21704 14.249 4.0151 14.249 3.92159 14.1692C3.84045 14.0999 3.79739 13.9959 3.80577 13.8895C3.81541 13.7669 3.95821 13.6242 4.24379 13.3386L9.91242 7.66994C10.1764 7.40593 10.3084 7.27392 10.4607 7.22446C10.5946 7.18096 10.7388 7.18096 10.8727 7.22446C11.0249 7.27392 11.1569 7.40593 11.4209 7.66994L14 10.249V11.049M10.8 14.249C11.9201 14.249 12.4802 14.249 12.908 14.031C13.2843 13.8393 13.5903 13.5333 13.782 13.157C14 12.7292 14 12.1691 14 11.049M10.8 14.249H5.2C4.0799 14.249 3.51984 14.249 3.09202 14.031C2.71569 13.8393 2.40973 13.5333 2.21799 13.157C2 12.7292 2 12.1691 2 11.049V5.44902C2 4.32892 2 3.76887 2.21799 3.34104C2.40973 2.96472 2.71569 2.65876 3.09202 2.46701C3.51984 2.24902 4.0799 2.24902 5.2 2.24902H10.8C11.9201 2.24902 12.4802 2.24902 12.908 2.46701C13.2843 2.65876 13.5903 2.96472 13.782 3.34104C14 3.76887 14 4.32892 14 5.44902V11.049M7 5.91569C7 6.65207 6.40305 7.24902 5.66667 7.24902C4.93029 7.24902 4.33333 6.65207 4.33333 5.91569C4.33333 5.17931 4.93029 4.58236 5.66667 4.58236C6.40305 4.58236 7 5.17931 7 5.91569Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const NoEffectsIcon = (props: ComponentProps<'svg'>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_8706_10805)">
      <path
        d="M3.28659 3.28683L12.7133 12.7135M14.6666 8.00016C14.6666 11.6821 11.6818 14.6668 7.99992 14.6668C4.31802 14.6668 1.33325 11.6821 1.33325 8.00016C1.33325 4.31826 4.31802 1.3335 7.99992 1.3335C11.6818 1.3335 14.6666 4.31826 14.6666 8.00016Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_8706_10805">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export interface BackgroundDropdownProps {
  value?: BackgroundType;
  onChange?: (value: BackgroundType | undefined) => void;
  disabled?: boolean;
}

type TriggerProps = ComponentProps<'button'> & {
  active?: boolean;
};

const Trigger = ({
  active = false,
  disabled = false,
  className,
  ...props
}: TriggerProps) => {
  const { t } = useTranslation();

  return (
    <button
      data-tip={t('videocall__tooltip_background')}
      data-place="top"
      className={classNames(
        'btn-control',
        active && 'btn-control-off',
        disabled && 'opacity-40',
        className
      )}
      type="button"
      disabled={disabled}
      {...props}
    >
      <TriggerIcon
        className={classNames(
          'w-6 h-6',
          active ? 'text-[#505050]' : 'text-white'
        )}
        starClassName={active ? 'text-[#505050]' : 'text-white'}
      />
    </button>
  );
};

const BackgroundDropdown = ({
  value = undefined,
  onChange,
  disabled = false,
}: BackgroundDropdownProps) => {
  const { t } = useTranslation();
  const dropdown = useDropdown();

  const handleClick = (newValue: BackgroundType | undefined) => () => {
    dropdown.close();
    onChange?.(value === newValue ? undefined : newValue);
  };

  const options = [
    {
      id: 1,
      value: undefined,
      icon: <NoEffectsIcon className="shrink-0" />,
      text: t('videocall__background_selector_none'),
    },
    {
      id: 2,
      value: Background.Blur,
      icon: <BlurIcon className="shrink-0" />,
      text: t('videocall__background_selector_blur'),
    },
    {
      id: 3,
      value: Background.Image,
      icon: <ImageIcon className="shrink-0" />,
      text: t('videocall__background_selector_image'),
    },
  ] as const;

  return (
    <div className="relative">
      <Trigger
        disabled={disabled}
        onClick={dropdown.toggle}
        active={!!value || dropdown.isOpen}
      />
      <DropdownMenu
        open={dropdown.isOpen}
        onClose={dropdown.close}
        className="bottom-[100%] right-0 mb-2.5 w-[230px] py-0 rounded-lg overflow-hidden"
      >
        {options.map((option) => (
          <DropdownOption
            key={option.id}
            className={classNames(
              'flex items-center gap-2 px-3.5 py-3',
              !!value && value === option.value
                ? 'bg-blue-light text-primary'
                : 'text-[##6D658B]'
            )}
            onClick={handleClick(option.value as BackgroundType | undefined)}
          >
            {option.icon}
            <span className="text-sm font-light">{option.text}</span>
          </DropdownOption>
        ))}
      </DropdownMenu>
    </div>
  );
};

export default BackgroundDropdown;
